import Vue from 'vue';
import { clac } from '@/config/math';
import typeMap from './typeMap';

const filters = {
    // ex: 123456 => 12.34万
    toWan(number) {
        if (!number) return 0;
        return number >= 10000 ? `${clac('/', number, 10000).toFixed(1)}万` : number;
    },

    // ex: 哈哈哈哈哈 => 哈哈哈哈...
    cutText(value, length = 4) {
        return value && value.length > length ? `${value.slice(0, length)}...` : value;
    },
    typeToText(type, mapName = '$$default') {
        if (!typeMap[mapName]) return '没有该映射！';
        return typeMap[mapName][type] || '没有该映射！';
    },
    numDevide100(num) {
        if (!num) return 0;
        return num / 100;
    },
    // 计算到期日期
    dateCount(endTime) {
        // 现在时间
        const now = new Date().getTime();
        const days = (endTime - now) / 1000 / 3600 / 24;
        const day = Math.floor(days);
        const hours = (days - day) * 24;
        const hour = Math.floor(hours);
        const minutes = (hours - hour) * 60;
        const minute = Math.floor(minutes);
        // const seconds = (minutes - minute) * 60;
        // const second = Math.floor(seconds);
        if (day > 0) {
            return ` ${day} 天`;
        }
        return ` ${hour} 小时 ${minute} 分`;
    },
};

Object.entries(filters).forEach(([name, fn]) => {
    Vue.filter(name, fn);
});
